module.exports = __webpack_public_path__ + "img/howtouse11.f708ac01.jpg";